import { render, staticRenderFns } from "./EditPDPObjectiveModal.vue?vue&type=template&id=53f31001&scoped=true&"
import script from "./EditPDPObjectiveModal.vue?vue&type=script&lang=js&"
export * from "./EditPDPObjectiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f31001",
  null
  
)

export default component.exports